// Centralized site copy & assets so user can swap easily later.
export const SITE = {
  brand: "Tina's Cleaning",
  tagline: "SEATTLE • TACOMA • BELLEVUE",
  phone: "+48 572 410 075",
  whatsapp: "48572410075",
  email: "taniamac90210@gmail.com",
  thumbtack:
    "https://www.thumbtack.com/wa/seattle/house-cleaning/pure-wave-by-tina-llc/service/552212518389948416",
  hero: {
    illustration:
      "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/ranfdopf_Mask%20Group.png",
    room: "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/mri4yr67_Frame%2061.jpg",
  },
  ctaIllustrations:
    "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/rejmc6i1_Background%2BBorder.png",
  beforeAfter: {
    before:
      "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/7r01cr3h_image%2015.png",
    after:
      "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/ddhzkb3y_image%2014.png",
  },
};

export const SERVICES = [
  {
    id: "regular",
    title: "Regular Cleaning (Standard Cleaning)",
    icon: "Sparkles",
    items: [
      "Cleaning all main surfaces in the home",
      "Vacuuming and mopping floors",
      "Bathroom cleaning (toilet, sink, shower, mirrors)",
      "Kitchen cleaning (countertops, outside of appliances)",
      "Dusting furniture and visible surfaces",
      "Taking out the trash",
      "Light tidying and minimal organization of items in living areas",
    ],
  },
  {
    id: "deep",
    title: "Deep Cleaning",
    icon: "SprayCan",
    items: [
      "Full detailed cleaning of the entire home",
      "Deep bathroom cleaning (tile, grout, soap scum, buildup)",
      "Heavy degreasing of kitchen surfaces",
      "Cleaning microwave and range hood",
      "Cleaning hard-to-reach areas (baseboards, corners, vents)",
      "Dusting all surfaces, including detailed areas",
      "Wiping doors, handles, and light switches",
    ],
  },
  {
    id: "move",
    title: "Move-In / Move-Out Cleaning",
    icon: "ArrowRightLeft",
    items: [
      "Full deep cleaning of empty homes",
      "Cleaning inside all cabinets, drawers, and closets",
      "Full kitchen and bathroom sanitizing",
      "Cleaning baseboards, frames, doors, and all surfaces",
      "Removing dust, dirt, and leftover residue from previous tenants",
      "Preparing the home for move-in or listing",
    ],
  },
  {
    id: "airbnb",
    title: "Airbnb / Rental Cleaning",
    icon: "BedDouble",
    items: [
      "Fast and detailed turnover cleaning between guests",
      "Preparing the home for new check-ins",
      "Changing and unmaking bed linens (if provided)",
      "Sanitizing bathrooms and kitchen areas",
      "Vacuuming and mopping all floors",
      "Restocking basic hygiene supplies (toilet paper, soap, paper towels — if available)",
      "Organizing items and final staging",
      "Creating a clean \"hotel-style\" presentation",
    ],
  },
  {
    id: "post",
    title: "Post-Construction Cleaning",
    icon: "Hammer",
    items: [
      "Removing construction dust and debris",
      "Deep cleaning all surfaces throughout the space",
      "Cleaning windows, frames, and sills",
      "Removing paint, glue, and construction residue",
      "Detailed cleaning of kitchen and bathrooms",
      "Final polishing of all surfaces",
      "Preparing the space for comfortable living",
    ],
  },
];

// Real customer reviews from Pure Wave by Tina LLC
export const TESTIMONIAL_IMAGES = [
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/k4d91ohh_640%20%2827%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/vdx7csn8_640%20%2826%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/hpj80zrx_640%20%2822%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/riqsuk4j_640%20%2821%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/9cgss19z_640%20%2820%29%20%281%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/7gfo100i_640%20%2817%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/rfx93vf0_640%20%2815%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/icd7xzq0_640%20%2813%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/2hbx3gd3_640%20%2812%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/ehhl3una_640%20%288%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/xu153vtg_640%20%286%29.jpg",
  "https://customer-assets.emergentagent.com/job_tina-quote-portal/artifacts/gwu3h7r7_640%20%285%29%20%281%29.jpg",
];

export const TESTIMONIALS = [
  {
    name: "Lauren M.",
    rating: 5,
    quote:
      "Anastasia cleaned my downtown apartment, and I couldn't be happier with the results. It's a modern one-bedroom with lots of glass surfaces and stainless steel appliances, which usually show every fingerprint. She made everything shine without leaving streaks. The bathroom tiles and grout looked brand new, and even the small details like baseboards were spotless.",
  },
  {
    name: "Aiyana R.",
    rating: 5,
    quote:
      "Tina's team did an excellent job and treated my home with care and respect. The cleaning felt thorough but not invasive, which I really value. It's clear they take pride in their work. I would confidently recommend this company to anyone looking for dependable cleaning services.",
  },
  {
    name: "Marisol Q.",
    rating: 5,
    quote:
      "Tina's cleaning service exceeded my expectations. They arrived on time, brought all their own supplies, and worked efficiently without cutting corners. What I appreciated most was how respectful and organized they were. I came home to a spotless space that felt calm and welcoming.",
  },
  {
    name: "Aniket R.",
    rating: 5,
    quote:
      "I've hired several cleaning services over the years, and Tina truly stands out. The team was extremely detail-oriented and didn't rush through the job. They noticed things I usually have to point out myself. My place felt not just clean, but refreshed and well cared for. Highly reliable and professional.",
  },
  {
    name: "Bobbi M.",
    rating: 5,
    quote: "Very efficient and thorough cleaning. Would hire again. Thank you!",
  },
  {
    name: "Laura B.",
    rating: 4,
    quote:
      "Very good cleaning service overall. Communication was excellent, fast, and professional. The team did a great job with the main areas, and everything looked tidy and well organized. A few small details, such as edges near baseboards and some spots behind furniture, could use a bit more attention. Overall, I'm happy with the service and would recommend them.",
  },
  {
    name: "Seong-Min K.",
    rating: 5,
    quote:
      "This was my first time using Tina, and it definitely won't be the last. The quality of work was consistent from room to room, and nothing felt overlooked. Communication was clear, and the service felt very professional without being impersonal. Highly recommended.",
  },
  {
    name: "Kavita S.",
    rating: 5,
    quote:
      "The cleaning made my home feel reset, like a fresh start. Very satisfying experience.",
  },
  {
    name: "Reena G.",
    rating: 5,
    quote: "They did good job with cleaning. I liked it.",
  },
  {
    name: "M G.",
    rating: 5,
    quote:
      "Showed up on time, did a great job and made sure I was satisfied before they left. Thank you!",
  },
  {
    name: "Alejandro C.",
    rating: 5,
    quote:
      "Professional, polite, and efficient. No unnecessary talking — just great results.",
  },
];
